module.exports = __webpack_public_path__ + "b2897484c20485421d42cc1e9d9b383a.MP3";